import "./App.css";
import HeroSection from "./components/HeroSection/index";
import Navbar from "./components/navbar/index";
import AboutSection from "./components/AboutSection/Index";
import TeamSection from "./components/TeamSection/Index";
import Footer from "./components/Footer";
import { SkeletonTheme } from "react-loading-skeleton";

function App() {
	return (
		<div className="overflow-hidden">
			<SkeletonTheme baseColor="#5A5A5A" highlightColor="#4be4c0">
				<Navbar />
				<HeroSection />
				<AboutSection />
				<TeamSection />
				<Footer />
			</SkeletonTheme>
		</div>
	);
}

export default App;
